import { API_CONFIG } from './config/api'
import { apiPost } from '../shared/utils/apiClient'

// Import auto-generated types from Swagger schema
import type {
  CheckProofDto,
  GeneratePayloadResponseDto,
  AuthResponseDto,
} from '../types/generated'

// Re-export types for convenience
export type { CheckProofDto, GeneratePayloadResponseDto, AuthResponseDto }

// ===== API Functions =====

/**
 * Generate a payload for TON Connect proof authentication
 * @returns Promise with payload token (short-lived JWT) and payload hash
 */
export const generatePayload =
  async (): Promise<GeneratePayloadResponseDto> => {
    const response = await apiPost(
      API_CONFIG.endpoints.auth.generatePayload,
      undefined, // No body needed
      {
        includeAuth: false, // No auth needed for generating payload
      },
    )

    if (!response.ok) {
      throw new Error(
        `Failed to generate payload: ${response.status} ${response.statusText}`,
      )
    }

    return await response.json()
  }

/**
 * Verify TON Connect proof and get authentication token
 * @param proofData - The proof data signed by the user's wallet
 * @returns Promise with JWT token and user data
 */
export const checkProof = async (
  proofData: CheckProofDto,
): Promise<AuthResponseDto> => {
  const response = await apiPost(
    API_CONFIG.endpoints.auth.checkProof,
    proofData,
    {
      includeAuth: false, // No auth needed for checking proof (we're getting the token)
    },
  )

  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(
      `Failed to verify proof: ${response.status} ${response.statusText}. ${errorText}`,
    )
  }

  return await response.json()
}
